import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './features/auth/AuthContext.js';
import LoginPage from './features/auth/LoginPage.js';
import PrivacyPolicy from './features/legal/PrivacyPolicy.js';
import Sidebar from './features/lists/Sidebar.js';
import Home from './features/home/Home.js';
import TaskList from './features/tasks/TaskList.js';
import ToastContainer from './shared/components/Toast.js';
import Header from './shared/components/Header.js';
import { useUIStore, closeMobileSidebar } from './store/ui.store.js';

function ProtectedLayout() {
  const { activeListId } = useUIStore();

  // sidebarOpen defaults to true (correct for desktop, where it's always
  // visible regardless of this flag). On a mobile-width viewport it also
  // drives the off-canvas drawer, so start it closed there instead of
  // covering the screen on first load.
  useEffect(() => {
    if (window.matchMedia('(max-width: 640px)').matches) {
      closeMobileSidebar();
    }
  }, []);

  return (
    <div className="app-layout">
      <Header />
      <div className="app-body">
        <Sidebar />
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tasks" element={<TaskList listId={activeListId ?? undefined} />} />
            <Route path="/dashboard" element={<Navigate to="/" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
      <ToastContainer />
    </div>
  );
}

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="app-loading">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route
        path="/*"
        element={
          <RequireAuth>
            <ProtectedLayout />
          </RequireAuth>
        }
      />
    </Routes>
  );
}
